import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import FAQSection from './components/FAQSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <CommentsSection />
        <IndexSection />
        <UpdatesSection />
        <FAQSection />
        <FeaturesSection />
        <RankingSection />
        <CarouselSection />
        <AboutSection />
        <MediaSection />
        <AppSection />
        <ContactSection />
        <TopicsSection />
      </main>
      <Footer />
    </div>
  );
}